<template>
<div>
  <b-tabs pills card>
  <b-tab title="Ingreso Con QR" active @click="tabsDesactive">
    <b-card title="Acceso QR" class="text-uppercase text-center" v-if="mostrar"> 
        <b-col v-if="idtab === 0">
            <qrcode-reader @decode="onDecode"></qrcode-reader>
        </b-col>
    </b-card>
  </b-tab>
  <b-tab title="Ingreso Con Aplicacion" @click="tabsActive">
     <b-col align='center'>
         <qr-code :text='code' :size=250 error-level='L'></qr-code>
         <!-- <h3>Codigo: {{code}}</h3> -->
      </b-col>
  </b-tab>
  </b-tabs>
    
</div>
</template>

<script>
export default {
  name: 'accesqr',
  data: function () {
    return {  
      idtab: 0,
      code: '',
      varReload: null,
      mainPath: "",
      varMensaje: '',
      varImg:'',
      varimgtext: '',
      mostrar: true
    }
  },
  created () {
    this.search()
  },
  methods: {
    tabsActive: function (){
      this.idtab = 1;
    },
    tabsDesactive: function() {
      this.idtab = 0;
    },
    onDecode: function (decode) {
      this.mostrar = false;
      if(decode.length>2){
        let resp = this.$store.dispatch('validateCredentialqracces', decode).then(response=>{
          this.varMensaje= this.$store.getters.controlaccesoqracces.mensaje
          this.varImg= this.$store.getters.controlaccesoqracces.img      
          this.url();
          this.$root.showInfoDialog('alerta',this.varimgtext, 'Aceptar') 
            if(this.$store.getters.controlaccesoqracces.mensaje){
              let varReload = setInterval(this.reload, 2000)      
            }
          })
      }else{
        setTimeout(()=>{
          this.mostrar = true; 
        },200);
      }  
    },
    url :function() {
    this.mainPath = localStorage.getItem("urlApi");
    this.mainPath = this.mainPath.replace("/api", "");
    this.mainPath += this.varImg;
    this.varimgtext='<div style="text-align: center;"><img  width="250" height="250" src='+this.mainPath+' class="img-thumbnail img-fluid rounded-circle" alt="BV"></img></div><div style="text-align: center;"><h1>'+this.varMensaje+'</h1></span></div>'  
  },
    reload: function (){          
      location.reload()
    },
    search () {
      let json = JSON.stringify(this.$route.params)
      this.$store.dispatch('qraccesShow', json).then(response => {
        this.code = this.$store.getters.controlaccesoqracces.code
        if(this.varReload == null){          
          this.varReload = setInterval(this.search, 50000)      
        }
      }).catch(error => {
        console.log(error)
      })
    },
    
    consultar() {
      this.$store.dispatch("adminUsersprofiledata").then(Response => {
        this.mainPath += this.$store.getters.adminUsers.url;
      });
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/components/modules/controlacceso/qracces.vue